import { render, staticRenderFns } from "./UsageRecordList.vue?vue&type=template&id=f2cb1c20&"
import script from "./UsageRecordList.vue?vue&type=script&lang=js&"
export * from "./UsageRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports